import { combineReducers } from 'redux';
import { IdentityReducer } from './IdentityReducer';


export const RootReducer = combineReducers({
    Profile: IdentityReducer
} as any);


// WEBPACK FOOTER //
// ./src/reducers/ReducersIndex.tsx